import { lazy } from 'react';
import { ProtectedRoute } from '../components/ProtectedRoute';
import PasswordContextProvider from '../contexts/PasswordContext';

const permissionIds = [34, 41, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 54, 55, 56, 58, 59, 61, 66, 67, 68, 69, 74, 84, 99, 101];

const generalJournalRouteConfig = [
  {
    parent: {
      exact: true,
      path: 'general-journal/entries',
      element: ProtectedRoute,
      permission_id: permissionIds,
    },
    child: {
      index: true,
      exact: true,
      strict: true,
      component: lazy(() => import('../routes/general journal/adjusting-entries/mutate-entries/DocumentAdjustingEntriesMutate.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/AP',
      element: ProtectedRoute,
      rootPath: 'AP',
      permission_id: 34,
    },
    child: {
      component: lazy(() => import('../routes/general journal/adjusting-entries/DocumentGeneralJournalAdjustingEntries.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/AR',
      rootPath: 'AR',
      element: ProtectedRoute,
      permission_id: 60,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-AR/GeneralJournalAR.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/treasury-12',
      element: ProtectedRoute,
      rootPath: 'treasury-12',
      permission_id: 44,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-treasury/GeneralJournal-Treasury.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/treasury-22',
      element: ProtectedRoute,
      rootPath: 'treasury-22',
      permission_id: 86,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-treasury/GeneralJournal-Treasury22.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/cost-and-budget-12',
      element: ProtectedRoute,
      rootPath: 'cost-and-budget-12',
      permission_id: 45,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-cost-and-budget/GeneralJournal-CB.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/cost-and-budget-22',
      element: ProtectedRoute,
      rootPath: 'cost-and-budget-22',
      permission_id: 73,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-cost-and-budget/GeneralJournal-CB22.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/cost-and-budget-30',
      element: ProtectedRoute,
      rootPath: 'cost-and-budget-30',
      permission_id: 74,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-cost-and-budget/GeneralJournal-CB30.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/fixed-asset-12',
      element: ProtectedRoute,
      rootPath: 'fixed-asset-12',
      permission_id: 46,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-fixed-asset/GeneralJournal-FixedAsset.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/fixed-asset-22',
      element: ProtectedRoute,
      rootPath: 'fixed-asset-22',
      permission_id: 72,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-fixed-asset/GeneralJournal-FixedAsset22.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/confidential-12',
      element: ProtectedRoute,
      rootPath: 'confidential-12',
      permission_id: 47,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-confidential/GeneralJournal-Confidential.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/confidential-22',
      element: ProtectedRoute,
      rootPath: 'confidential-22',
      permission_id: 78,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-confidential/GeneralJournal-Confidential22.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/confidential-30',
      element: ProtectedRoute,
      rootPath: 'confidential-30',
      permission_id: 78,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-confidential/GeneralJournal-Confidential30.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/confidential',
      element: ProtectedRoute,
      rootPath: 'confidential',
      permission_id: 47,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-confidential/GeneralJournal-Confidential.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/sales',
      element: ProtectedRoute,
      rootPath: 'sales',
      permission_id: 57,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-sales/GeneralJournalSales.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/FO',
      element: ProtectedRoute,
      rootPath: 'FO',
      permission_id: 58,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-FO/GeneralJournalFO.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/live',
      element: ProtectedRoute,
      rootPath: 'live',
      permission_id: 59,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-live/GeneralJournalLive.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: '/general-journal/ap-specialist-12',
      element: ProtectedRoute,
      rootPath: 'ap-specialist-12',
      permission_id: 66,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-specialist/GeneralJournal-APSpecialist.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/ap-specialist-22',
      element: ProtectedRoute,
      rootPath: 'ap-specialist-22',
      permission_id: 66,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-specialist/GeneralJournal-APSpecialist22.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/pcf',
      element: ProtectedRoute,
      rootPath: 'pcf',
      permission_id: 67,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-PCF/GeneralJournal-PCF.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/accruals-and-reversals',
      element: ProtectedRoute,
      rootPath: 'accruals-and-reversals',
      permission_id: 84,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-accrual-reversal/GeneralJournal-AccrualReversal.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/accrual-and-reversal',
      element: ProtectedRoute,
      permission_id: 43,
      rootPath: 'accrual-and-reversal',
    },
    child: {
      component: lazy(() => import('../routes/general journal/accrual-reversal/DocumentGeneralJournalAccrualReversal.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/year-end',
      element: ProtectedRoute,
      rootPath: 'year-end',
      permission_id: 99,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-year-end/GeneralJournal-YearEnd.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
    {
    parent: {
      exact: true,
      path: 'general-journal/confidential-year-end',
      element: ProtectedRoute,
      rootPath: 'confidential-year-end',
      permission_id: 101,
    },
    child: {
      component: lazy(() => import('../routes/general journal/gj-confidential-year-end/GeneralJournal-ConfidentialYearEnd.jsx')),
      wrapper: PasswordContextProvider,
    },
  },

];

const accrualReversalRouteConfig = [
  {
    parent: {
      exact: true,
      path: 'general-journal/accrual-and-reversal',
      element: ProtectedRoute,
      permission_id: 43,
      rootPath: 'accrual-and-reversal',
    },
    child: {
      component: lazy(() => import('../routes/general journal/accrual-reversal/DocumentGeneralJournalAccrualReversal.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/accrual-reversal-entries',
      element: ProtectedRoute,
      permission_id: 43,
    },
    child: {
      index: true,
      exact: true,
      component: lazy(() => import('../routes/general journal/accrual-reversal/mutate-entries/DocumentAccrualReversalMutate.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
  {
    parent: {
      exact: true,
      path: 'general-journal/all/accrual-reversal-entries',
      element: ProtectedRoute,
      permission_id: 43,
    },
    child: {
      index: true,
      exact: true,
      component: lazy(() => import('../routes/general journal/accrual-reversal/mutate-entries/DocumentAccrualReversalAllMutate.jsx')),
      wrapper: PasswordContextProvider,
    },
  },
];

export { accrualReversalRouteConfig };
export default generalJournalRouteConfig;
